module.exports = __webpack_public_path__ + "static/media/controls.e0292c50.svg";